var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunshadeOpenMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,0H13c-2.7568359,0-5,2.2431641-5,5v38c0,2.7568359,2.2431641,5,5,5h22c2.7568359,0,5-2.2431641,5-5V5 C40,2.2431641,37.7568359,0,35,0z M13,2h22c1.6542969,0,3,1.3457031,3,3v11H10V5C10,3.3457031,11.3457031,2,13,2z M35,46H13 c-1.6542969,0-3-1.3457031-3-3V18h28v25C38,44.6542969,36.6542969,46,35,46z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 34,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,30c0.2558594,0,0.5117188-0.0976562,0.7070312-0.2929688l4-4l-1.4140625-1.4140625L25,26.5859375V20h-2v6.5859375 l-2.2929688-2.2929688l-1.4140625,1.4140625l4,4C23.4882812,29.9023438,23.7441406,30,24,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,7.4140625V14h2V7.4140625l2.2929688,2.2929688l1.4140625-1.4140625l-4-4 c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0l-4,4l1.4140625,1.4140625L23,7.4140625z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshadeOpenMedium);
export default __webpack_public_path__ + "static/media/sunshade-open--medium.15f63d743ceb531d55bf21730d3c7a0b.svg";
export { ForwardRef as ReactComponent };